import { Controller } from '@hotwired/stimulus'

// Tracks affiliate link clicks for analytics
// Usage: data-controller="affiliate-click" on parent element
// On link: data-action="click->affiliate-click#track"
//          data-affiliate-click-product-id-param="123"
//          data-affiliate-click-retailer-param="Amazon"
//          data-affiliate-click-url-param="https://..."
export default class extends Controller {
  track(event) {
    const { productIdParam, retailerParam, urlParam } = event.params

    if (!productIdParam || !retailerParam || !urlParam) {
      console.warn('Affiliate click missing required params')
      return
    }

    // Send tracking request in background - don't block navigation
    this.sendTrackingRequest(productIdParam, retailerParam, urlParam)
  }

  sendTrackingRequest(productId, retailer, clickedUrl) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    // Use sendBeacon for non-blocking request that survives page navigation
    if (navigator.sendBeacon) {
      const formData = new FormData()
      formData.append('product_id', productId)
      formData.append('retailer', retailer)
      formData.append('clicked_url', clickedUrl)
      formData.append('authenticity_token', csrfToken || '')

      navigator.sendBeacon('/api/v1/affiliate_clicks', formData)
    } else {
      // Fallback for older browsers
      fetch('/api/v1/affiliate_clicks', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken || ''
        },
        body: JSON.stringify({
          product_id: productId,
          retailer: retailer,
          clicked_url: clickedUrl
        }),
        keepalive: true // Allows request to survive page navigation
      }).catch((err) => {
        console.warn('Failed to track affiliate click:', err)
      })
    }
  }
}
